import * as React from 'react';
import { GroundfloorManagementAPIs } from '@groundfloor-platform/mgmt-service-g-sdk';

export function addMethodInterceptor<T extends object>(instance: T): T {
  return Object.entries(instance).reduce((acc, [key, val]) => {
    const handler: ProxyHandler<T> = {
      get(target, prop) {
        if (typeof target[prop as keyof T] === 'function') {
          return new Proxy(target[prop as keyof T] as any, {
            apply: (target, thisArg, argumentsList) => {
              console.debug('Api Call: ', key, prop, ' Args: ', argumentsList);
              return Reflect.apply(target, thisArg, argumentsList);
            }
          });
        } else {
          return Reflect.get(target, prop);
        }
      }
    };

    if (typeof val === 'object' && val !== null) {
      return {
        ...acc,
        [key]: new Proxy(val, handler)
      };
    } else {
      return {
        ...acc,
        [key]: val
      };
    }
  }, {} as T);
}

const ApiContext = React.createContext<GroundfloorManagementAPIs>(undefined!);

export const useApi = () => {
  return React.useContext(ApiContext);
};

export const ApiContextProvider = ({ ...props }: React.PropsWithChildren<{ api: GroundfloorManagementAPIs }>) => {
  return <ApiContext.Provider value={props.api} {...props} />;
};

export function parseErrorMessage(message?: string) {
  if (!message) return '';

  let parsedMessage = message;

  try {
    const parsed = JSON.parse(message);
    if (typeof parsed === 'object' && 'message' in parsed) {
      parsedMessage = parsed.message;
    }
    if (typeof parsed === 'string') {
      parsedMessage = parsed;
    }
  } catch (e) {}

  return parsedMessage;
}
